import React from "react";
import Styles from "../../Styles/CommomDashboard/MainDashboard.module.css";
import Listing from "./Listing";
import AvailableListing from "./AvailableListing";
import FilterSection from "./FilterSection";
import { useSelector } from "react-redux";

const MainDashboard = ({
  getMatchingProfilesCon,
  setMatchingProfiles,
  selectedCardIndex,
  setSelectedCardIndex,
  setSelectedCardData,
  formResetFlag,
  setFormResetFlag,
  allConCapacity,
  matchingProfiles,
  selectedCardData,
  allGenCapacity,
  getMatchingProfiles,
  setFIlterModal,
  filterModal,
}) => {
  const role = useSelector((state) => state?.sessionState?.role);

  return (
      <div className={Styles.listingSection}>
        <div>
          <Listing
            getMatchingProfilesCon={
              role === "CONSUMER" ? getMatchingProfilesCon : getMatchingProfiles
            }
            setMatchingProfiles={setMatchingProfiles}
            selectedCardIndex={selectedCardIndex}
            setSelectedCardIndex={setSelectedCardIndex}
            setSelectedCardData={setSelectedCardData}
            formResetFlag={formResetFlag}
            setFormResetFlag={setFormResetFlag}
            displayList={role === "CONSUMER" ? allConCapacity : allGenCapacity}
          />
        </div>
        <div className={Styles.availableListingSec}>
          <AvailableListing
            matchingProfiles={matchingProfiles}
            getMatchingProfilesCon={
              role === "CONSUMER" ? getMatchingProfilesCon : getMatchingProfiles
            }
            selectedCardData={selectedCardData}
            displayList={role === "CONSUMER" ? allConCapacity : allGenCapacity}
            formResetFlag={formResetFlag}
            filterModal={filterModal}
            setFIlterModal={setFIlterModal}
            getMatchingProfiles={getMatchingProfiles}
            selectedCardIndex={selectedCardIndex}
          />
        </div>
      </div>
  );
};

export default MainDashboard;
